import { createRoute } from '@tanstack/react-router';

import { AccessGuard } from 'src/guards/AccessGuard';
import { AuthGuard } from 'src/guards/AuthGuard';
import { ConfigurationDefaultPage } from 'src/pages/configuration/ConfigurationDefaultPage';
import { ConfigurationPage } from 'src/pages/configuration/ConfigurationPage';
import { NotFoundFeature } from 'src/pages/errors/NotFoundFeature';
import { RootRoute } from 'src/routes/__root';

export const ConfigurationRoute = createRoute({
  getParentRoute: () => RootRoute,
  path: '/configuration',
  validateSearch: (search: Record<string, unknown>) => {
    return {
      sessionId:
        typeof search.sessionId === 'string' ? search.sessionId : undefined,
    };
  },
  component: () => (
    <AuthGuard>
      <AccessGuard>
        <ConfigurationPage />
      </AccessGuard>
    </AuthGuard>
  ),
  notFoundComponent: () => (
    <NotFoundFeature
      route='/configuration'
      routeTitleKey='Go to the configuration page'
    />
  ),
});

export const ConfigurationDefaultRoute = createRoute({
  getParentRoute: () => ConfigurationRoute,
  path: '/',
  component: ConfigurationDefaultPage,
});
